import React, { useContext, useEffect, useState } from "react";
import Header from "src/components/common/Header";
import UserForm from "src/components/user/UserForm";
import { getSingleUsers } from "src/store/user";
import { getUserProfile } from "src/store/profile";
import { useDispatch } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { MenuContext } from "src/context/MenuContext";
import Menu from "src/components/common/Menu";
import ScrollTop from "src/components/common/ScrollTop";
import CustomLoader from "src/components/common/CustomLoader";
import { ValidationMessages } from "src/components/common/ValidationMessage";

export default function EditInput() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const containerStyle = { width: "90%", margin: "0 auto" };
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [validationMessages, setValidationMessages] = useState([]);
  const [isEditScreen, setIsEditScreen] = useState(false);
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const userRes = await dispatch(getSingleUsers(id));
        if (userRes.payload) {
          // Fetch user profile after user data is loaded successfully
          await dispatch(getUserProfile(id));
          setIsEditScreen(true);
        }
        if (userRes.error) {
          setValidationMessages(userRes.error.message);
        }
        setLoading(false);
      } catch (error) {
        setValidationMessages([error.message]);
        setLoading(false);
      }
    };
    fetchUserData();
  }, []);

  const clickUserListBtn = () => {
    navigate("/userList");
  };

  const { visibleMenu } = useContext(MenuContext);
  return (
    <>
      {visibleMenu && <Menu />}
      <div className={visibleMenu ? "menu-open" : "menu-closed"}>
        <Header sx={{ mb: 500 }} />
        <section className="container-fluid contents-top user_input">
          {validationMessages && validationMessages.length > 0 && (
            <div style={{ background: "#ffe4e2" }}>
              <ValidationMessages
                messages={validationMessages}
                onClose={() => setValidationMessages([])}
              />
            </div>
          )}
          <div className="text-right">
            <button
              type="button"
              className="btn btn-default"
              onClick={clickUserListBtn}
            >
              <span
                className="glyphicon glyphicon-chevron-left"
                aria-hidden="true"
              ></span>
              Back to List
            </button>
          </div>
          {loading ? (
            <CustomLoader />
          ) : (
            <div style={containerStyle}>
              <h3 className="title-style01">Modify User Registration</h3>
              <UserForm
                id={id}
                isEditScreen={isEditScreen}
                setIsEditScreen={setIsEditScreen}
              />
            </div>
          )}
        </section>
      </div>
      <ScrollTop />
    </>
  );
}
